import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule, Provider} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FileManagerComponent} from './filemanager.component';
import {ToolbarComponent} from './toolbar/toolbar.component';
import {FilesListComponent} from './filesList/filesList.component';
import {PreviewComponent} from './preview/preview.component';
import {DropdownComponent} from './dropdown/dropdown.component';
import {FileManagerConfiguration} from './configuration/fileManagerConfiguration.service';
import {FileManagerUploader} from './filesList/fileManagerUploader.service';
import {TreeService} from './configuration/tree.service';
import {EffectsModule} from '@ngrx/effects';
import {FileManagerEffectsService} from './store/fileManagerEffects.service';
import {StoreModule} from '@ngrx/store';
import {fileManagerReducer} from './store/file-manager.reducer';
import {FileManagerActionsService} from './store/fileManagerActions.service';
import {FileTypeFilterService} from './services/fileTypeFilter.service';
import {SearchFilterService} from './services/searchFilter.service';
import {FileManagerDispatcherService} from './store/file-manager-dispatcher.service';
import {FileTypeFilterComponent} from './toolbar/fileTypeFilter/fileTypeFilter.component';
import {SearchFileComponent} from './toolbar/searchFile/searchFile.component';
import {FileManagerApiService} from './store/fileManagerApi.service';
import {ImageDataConverter} from './services/imageDataConverter.service';
import {FilemanagerNotifcations} from './services/FilemanagerNotifcations';
import {ConfirmationPopoverModule} from 'angular-confirmation-popover';
import {FileManagerBackendApiService} from './store/fileManagerBackendApi.service';
import {CurrentDirectoryFilesService} from './services/currentDirectoryFiles.service';
import {SelectionComponent} from './toolbar/selectionDropDown/selection.component';
import {FileComponent} from './filesList/file/file.component';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {IFileManagerConfiguration} from './configuration/IFileManagerConfiguration';
import {HttpClientModule} from '@angular/common/http';
import {CommonModule} from '@angular/common';
import {TreeModule} from "../angular2-tree/tree.module";
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {FileWideComponent} from "./filesList/file-wide/file-wide.component";
import {MessageModule} from "primeng/message";
import {MessageService} from "primeng/api";
import {AlertService} from "../../_services";
import {MatButton, MatButtonModule} from "@angular/material/button";
import {FileSelectDirective} from "../ng2-file-upload/file-select.directive";

@NgModule({
  imports: [
    CommonModule,
    ConfirmationPopoverModule,
    EffectsModule.forFeature([FileManagerEffectsService]),
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MessageModule,
    StoreModule.forFeature('files', fileManagerReducer),
    TranslateModule,
    TreeModule,
    MatButtonToggleModule,
    MatButtonModule,
    FileSelectDirective
  ],
  providers: [
    AlertService
  ],
  declarations: [
    FileManagerComponent,
    FileComponent,
    FileTypeFilterComponent,
    ToolbarComponent,
    FilesListComponent,
    DropdownComponent,
    PreviewComponent,
    SearchFileComponent,
    SelectionComponent,
    FileWideComponent
  ],
  exports: [FileManagerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FileManagerModule {

  public constructor(public translate: TranslateService) {
    this.setTranslationForEN();
    this.translate.use('en');
  }

  public setTranslationForEN(): void {
    this.translate.setTranslation('en', {
      RI_TREE_LBL_ADD_NODE: 'Add',
      RI_TREE_LBL_EDIT_NODE: 'Rename',
      RI_TREE_LBL_REMOVE_NODE: 'Delete',
      RI_TREE_LBL_DROP_ZONE: 'Drop here to move data to root level',
      RI_FM_BTN_LANDSCAPE: 'Landscape',
      RI_FM_BTN_PORTRAIT: 'Portrait',
      RI_FM_BTN_SAVE: 'Save',
      RI_FM_LBL_DELETE_SELECTION: 'Delete selection',
      RI_FM_LBL_INVERSE_SELECTION: 'Inverse selection',
      RI_FM_LBL_SEARCH_FOR: 'Search for...',
      RI_FM_LBL_SELECT_ALL: 'Select all',
      RI_FM_LBL_UNSELECT_ALL: 'Unselect all',
    });
  }

  public static forRoot(config: IFileManagerConfiguration, apiProvider: Provider = null): ModuleWithProviders<any> {
    return {
      ngModule: FileManagerModule,
      providers: [
        CurrentDirectoryFilesService,
        FileManagerActionsService,
        FileManagerApiService,
        FileManagerBackendApiService,
        FileManagerConfiguration,
        FileManagerDispatcherService,
        FileManagerEffectsService,
        FilemanagerNotifcations,
        FileManagerUploader,
        MessageService,
        FileTypeFilterService,
        ImageDataConverter,
        SearchFilterService,
        TreeService,
        {provide: 'fileManagerConfiguration', useValue: config},
        apiProvider ? apiProvider : FileManagerApiService
      ]
    };
  }

  public static forChild(config: IFileManagerConfiguration, apiProvider: Provider = null): ModuleWithProviders<any> {
    return {
      ngModule: FileManagerModule,
      providers: [
        CurrentDirectoryFilesService,
        FileManagerActionsService,
        FileManagerApiService,
        FileManagerBackendApiService,
        FileManagerConfiguration,
        FileManagerDispatcherService,
        FileManagerEffectsService,
        FilemanagerNotifcations,
        FileManagerUploader,
        FileTypeFilterService,
        ImageDataConverter,
        SearchFilterService,
        TreeService,
        {provide: 'fileManagerConfiguration', useValue: config},
        MessageService,
        apiProvider ? apiProvider : FileManagerApiService
      ]
    };
  }
}
